// @ts-nocheck
import React, { useEffect, useRef } from 'react';
import * as wordanimation from '../util/alaska.ui.oopsanimation';
import { signoutRedirect } from '../services/userService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import icons from '../constants/icons.ts';
import { useTranslation } from 'react-i18next';

function AccessDenied() {
  const ref = useRef();
  const handleSignout = () => {
    signoutRedirect();
  };
  const { t } = useTranslation();
  useEffect(() => {
    if (ref.current) {
      const initializingComponent = ref.current;
      const initCanvas =
        initializingComponent.getElementsByTagName('canvas')[0];
      initializingComponent.style.transition = `opacity 20ms, transform 20ms`;
      initializingComponent.style.opacity = 1;
      initializingComponent.style.display = null;
      wordanimation.init(initCanvas, t('DENIED'), t('Sorry, access denied'), [
        '#16beef',
        '#46B29D',
        '#BB5EBF',
        '#fe5557',
        '#b2178a',
      ]);
    }
  }, [ref, t]);
  return (
    <div className="page page--403">
      <main ref={ref}>
        <canvas></canvas>
        <button className="btn btn-primary" onClick={handleSignout}>
          <FontAwesomeIcon icon={icons.CHEVRON_LEFT}/>
          {' ' + t('Take me back to Alaska')}
        </button>
      </main>
    </div>
  );
}

export default AccessDenied;
